/**
 * Shared axios-retry condition for every axios instance in this app.
 *
 * AE2-7144: a browser retry stacks on top of the API's own Polly retry, so each status listed here
 * costs up to 16 executions of the same request. Only statuses that can plausibly succeed on a
 * second attempt belong here.
 *
 * Deliberately excluded:
 *  - 500, which is usually a deterministic downstream failure (a SQL command timeout, for example).
 *    Retrying cannot recover it and it multiplies load while the API is already struggling.
 *  - 404, which can never become a 200 on retry.
 */
const RETRYABLE_STATUSES = [408];

const isRetryableStatus = (status) => RETRYABLE_STATUSES.includes(status);

const shouldRetry = (error) => Boolean(error?.response) && isRetryableStatus(error.response.status);

export { RETRYABLE_STATUSES, isRetryableStatus, shouldRetry };
